var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"use-icon-font",style:(_vm.iconStyle),attrs:{"aria-hidden":"true"},on:{"click":_vm.handleClick}},[_c('use',{attrs:{"xlink:href":_vm.symbolId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }